module.exports = __webpack_public_path__ + "images/tips/guide-1@1x.3a63a6244ef2e7ade4d6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/guide-1@1x.png
// module id = 56GW
// module chunks = 12